export enum ResourceActionTypes {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    PATCH = 'PATCH',
    DELETE = 'DELETE',

    COPY = 'COPY',
    SAVE = 'SAVE',
    SUBMIT = 'SUBMIT',
    CANCEL = 'CANCEL',
    RETRACT = 'RETRACT',
    BACK_TO_DRAFT = 'BACK_TO_DRAFT',
    PUBLISH = 'PUBLISH',
    PREVIEW = 'PREVIEW',
    RENAME = 'RENAME',
    BULK_DELETE = 'BULK_DELETE',
    VISIBILITY = 'VISIBILITY',
    BULK_VISIBILITY = 'BULK_VISIBILITY',

    // Note Actions
    ADD_NOTE = 'ADD_NOTE',
    EDIT_NOTE = 'EDIT_NOTE',
    DELETE_NOTE = 'DELETE_NOTE',

    // Media Subscription & VIM
    PAUSED = 'PAUSED',
    ACTIVATED = 'ACTIVATED',

    // Digest
    SHARE = 'SHARE',

    // Journodex action
    ASSIGN = 'ASSIGN',
}
